/**
 * SCRIPT INJECTION FOR LOYALTY PAGES
 * 
 * Poligon Central location:
 * "System" -> Script Injection
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyHtmlHeadInjection',
  initialState: null as null | string,
  reducers: {
    setLoyaltyHtmlHeadInjection(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setLoyaltyHtmlHeadInjection } = slice.actions;

export default slice.reducer;
